import _ from 'lodash'
import axios from 'axios'
import ability from '@/libs/acl/ability'
import * as types from './types'
import { getCredentials, setCredentials, deleteCredentials, transformAbilities } from '@/helpers/credentials'
import { ADMIN_CREDENTIALS_STORAGE_KEY } from '@/constants/auth'
import { initialReportLock, normalizeReportLock } from './report_lock'

export default {
  [types.MUTATE_TOKEN]: (state, payload) => {
    const {
      token,
      user,
      abilities,
      consultant_level,
    } = payload
    // Outro usuário (troca de conta em outra aba): a trava em memória era do anterior.
    if ((state.user && state.user.id) !== (user && user.id)) {
      state.reportLock = initialReportLock()
    }
    if (token) {
      axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`
      }
      setCredentials(
        ADMIN_CREDENTIALS_STORAGE_KEY,
        { token, user, abilities, consultant_level }
      )
    } else {
      const stored = getCredentials(ADMIN_CREDENTIALS_STORAGE_KEY)
      setCredentials(
        ADMIN_CREDENTIALS_STORAGE_KEY,
        { ...stored, user, abilities, consultant_level }
      )
    }
    state.user = user
    state.consultant_level = consultant_level
    const transformedAbilities = transformAbilities(abilities)
    state.abilities = transformedAbilities
    ability.update(transformedAbilities)
  },
  [types.MUTATE_TOKEN_LOGOUT]: (state) => {
    deleteCredentials(ADMIN_CREDENTIALS_STORAGE_KEY)
    if (axios.defaults.headers.common) {
      delete axios.defaults.headers.common.Authorization
    }
    state.user = undefined
    state.abilities = undefined
    state.consultant_level = undefined
    state.report_pendencies = undefined
    state.pn_onboarding_status = null
    state.reportLock = initialReportLock()
    ability.update([])
  },
  [types.MUTATE_COMPANY_PENDENCIES]: (state) => {
    var today = new Date();
    state.company_pendencies_viewed = today.toDateString()
  },
  [types.MUTATE_SYSTEM_VERSION_NOTIFICATIONS]: (state, payload) => {
    state.announcement_notifications = payload
  },
  [types.MUTATE_PN_ONBOARDING_STATUS]: (state, payload) => {
    state.pn_onboarding_status = payload
  },
  // payload parcial é mesclado ao estado atual; `null` volta ao estado inicial (sem trava, sem checagem).
  [types.MUTATE_REPORT_LOCK]: (state, payload) => {
    state.reportLock = payload
      ? normalizeReportLock({ ...state.reportLock, ...payload })
      : initialReportLock()
  },
  [types.MUTATE_PN_DOCUMENT_ALERT_DISMISSED]: state => {
    if (state.pn_onboarding_status) {
      state.pn_onboarding_status = { ...state.pn_onboarding_status, document_alert: null }
    }
  },
}
